import campaignCategories from "./campaignCategories";
import { strCode } from "../../localizations/strCode";
import appUserRoles from "../../app/appUserRoles";

const campaignCategoriesOptions = [
  {
    id: campaignCategories.firmwareUpdate,
    value: strCode.FIRMARE_UPDATE_TITLE,
    accessRoles: [appUserRoles.FleetManager]
  },
  {
    id: campaignCategories.loyalty,
    value: strCode.LOYALTY_DESTINATION_OPTION,
    accessRoles: [appUserRoles.Admin]
  },
  {
    id: campaignCategories.informative,
    value: strCode.INFORMATIVE_CATEGORY_TITLE,
    accessRoles: [appUserRoles.Admin]
  },
  {
    id: campaignCategories.marketing,
    value: strCode.MARKETING_CATEGORY_TITLE,
    accessRoles: [appUserRoles.Admin]
  },
  {
    id: campaignCategories.conversion,
    value: strCode.CONVERSION_CATEGORY_TITLE,
    accessRoles: [appUserRoles.Admin]
  },
  {
    id: campaignCategories.system,
    value: strCode.SYSTEM_CATEGORY_TITLE,
    accessRoles: [appUserRoles.Admin]
  },
 
];

export default campaignCategoriesOptions;
